import { Injectable } from "@angular/core";
import { environment } from "../environments/environment.production";
import { HttpClient, HttpParams } from "@angular/common/http";
import {Observable} from 'rxjs';
//nombre del archivo: eliminarDocumentos.service.ts
@Injectable({
    providedIn: 'root'
})
export class EliminarDocumentos {
    private endPoint: string = `${environment.HOST_DOCUMENT}/documentos`

    constructor(private http: HttpClient){

    }
    eliminarDocumentos(id:number, strRfc:string, strNombreArchivo:string): Observable<any>{
        const url =  `${this.endPoint}/eliminarArchivo`;
        const params = new HttpParams()
      .set('id', id)
      .set('strRfc', strRfc)
      .set('strNombreArchivo', strNombreArchivo)

      return this.http.delete(url, {params: params, observe: 'response'});
    }

}
